export interface ConfirmationPageData {
  slug: string;
  oldSlugs: string[];
  title: string;
  headline?: string;
  subtitle?: string;
  body: string;
  email: string;
  metaTitle: string;
  metaDescription: string;
  relatedService?: string;
  reviewsLink?: boolean;
}

export const confirmationPages: ConfirmationPageData[] = [
  {
    slug: "youre-all-set-roof-replacement",
    oldSlugs: [],
    title: "YOU'RE ALL SET!",
    headline: "NEXT STOP: A BRAND NEW ROOF!",
    body: "Sit back and relax — our team will be in touch to schedule your roof replacement. We will send you email updates at every step of the process.",
    email: "info@kodiakstructures.com",
    metaTitle: "You're All Set — Roof Replacement | Kodiak Structures & Exteriors",
    metaDescription: "Your roof replacement estimate has been confirmed. Our team will be in touch soon.",
    relatedService: "/services/roof-replacement",
  },
  {
    slug: "youre-all-set-roof-repair",
    oldSlugs: [],
    title: "YOU'RE ALL SET!",
    headline: "WE'LL GET YOUR ROOF FIXED!",
    body: "Our team will reach out to schedule your roof repair. We'll keep you updated via email every step of the way.",
    email: "info@kodiakstructures.com",
    metaTitle: "You're All Set — Roof Repair | Kodiak Structures & Exteriors",
    metaDescription: "Your roof repair request has been received. We'll be in touch shortly.",
    relatedService: "/services/roof-repair",
  },
  {
    slug: "youre-all-set-siding",
    oldSlugs: [],
    title: "YOU'RE ALL SET!",
    headline: "NEW SIDING IS ON THE WAY!",
    body: "Sit back and relax — our team will be in touch to schedule your siding project. We will send you email updates at every step of the process.",
    email: "info@kodiakstructures.com",
    metaTitle: "You're All Set — Siding | Kodiak Structures & Exteriors",
    metaDescription: "Your siding estimate has been confirmed. Our team will be in touch soon.",
    relatedService: "/services/siding",
  },
  {
    slug: "youre-all-set-windows",
    oldSlugs: [],
    title: "YOU'RE ALL SET!",
    headline: "NEW WINDOWS COMING YOUR WAY!",
    body: "Our team will reach out to schedule your window replacement. We'll keep you updated via email every step of the way.",
    email: "info@kodiakstructures.com",
    metaTitle: "You're All Set — Windows | Kodiak Structures & Exteriors",
    metaDescription: "Your window replacement request has been received. We'll be in touch shortly.",
    relatedService: "/services/windows",
  },
  {
    slug: "youre-all-set-gutters",
    oldSlugs: [],
    title: "YOU'RE ALL SET!",
    headline: "YOUR GUTTERS ARE IN GOOD HANDS!",
    body: "Sit back and relax — our team will be in touch to schedule your gutter installation. We will send you email updates at every step of the process.",
    email: "info@kodiakstructures.com",
    metaTitle: "You're All Set — Gutters | Kodiak Structures & Exteriors",
    metaDescription: "Your gutter installation request has been confirmed. Our team will be in touch soon.",
    relatedService: "/services/gutters",
  },
  {
    slug: "youre-all-set-storm-damage",
    oldSlugs: [],
    title: "YOU'RE ALL SET!",
    headline: "WE'LL TAKE CARE OF THE STORM DAMAGE!",
    body: "Our team specializes in storm damage restoration and will guide you through the insurance claims process. We'll be in touch shortly to schedule your inspection.",
    email: "info@kodiakstructures.com",
    metaTitle: "You're All Set — Storm Damage | Kodiak Structures & Exteriors",
    metaDescription: "Your storm damage claim has been received. Our team will be in touch to schedule an inspection.",
    relatedService: "/services/roof-repair",
  },
  {
    slug: "thank-you",
    oldSlugs: ["contact-form-landing-page.html", "contact-form-landing-page"],
    title: "We're On It!",
    headline: "Your personalized quote will arrive by the end of the next business day.",
    body: "Join your neighbors across the Twin Cities Metro in trusting Kodiak Structures & Exteriors for all your roofing and exterior needs!",
    email: "info@kodiakstructures.com",
    metaTitle: "Thank You | Kodiak Structures & Exteriors",
    metaDescription: "Thank you for contacting Kodiak Structures & Exteriors. Your personalized quote is on the way.",
    reviewsLink: true,
  },
];
